import { gql } from '@apollo/client';

export const GET_PORTFOLIOS = gql`
  query GetPortfolios($portfolioCodes: [String!], $take: Int = 1000, $isMaster: Boolean) {
    portfolios(portfolioCodes: $portfolioCodes, take: $take, isMaster: $isMaster) {
      portfolioId
      portfolioCode
      portfolioName
      institutionId
    }
  }
`;
